import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { getServiceTimeUnitLocalizationByServiceOrderId } from '../selectors/orderItems';

interface SpaceOrderItemTimeNameProps {
    timeUnitText: string | undefined;
}

interface SpaceOrderItemTimeNameOwnProps {
    serviceOrderId: string;
}

const SpaceOrderItemTimeUnitLabel = ({ timeUnitText }: SpaceOrderItemTimeNameProps) => <>{timeUnitText}</>;

export default connect<SpaceOrderItemTimeNameProps, {}, SpaceOrderItemTimeNameOwnProps, ApplicationState>(
    createStructuredSelector({
        timeUnitText: getServiceTimeUnitLocalizationByServiceOrderId,
    })
)(SpaceOrderItemTimeUnitLabel);
